import React, { useEffect, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { usePresentacionContext } from "../context/presentacion.context";
import TransaccionesLotes from "./TransaccionesLotes";
import PresentacionesDatosGenerales from "./PresentacionesDatosGenerales";
import Comprobantes from "./Comprobantes";
import ImpuestosTasas from "./ImpuestosTasas";
import AccionesPresentaciones from "./AccionesPresentacion";
import Mask from "../../shared/components/mask/Mask";
import { ProgressSpinnerDemo } from "../../shared/components/progressSpinnerDemo/ProgressSpinnerDemo";
import { Redirect, useLocation } from "react-router";
import { useGlobalContext } from "../../shared/context/global.context";
import ImpuestosTasasDataTableAutomatico from "./ImpuestosTasasDataTableAutomatico";
import { IMPUESTO_AUTOMATICO, IMPUESTO_MANUAL, INICIADA_COMERCIO, RECHAZADA} from "../utilities/constants";
import { ProductoComercio } from "../models/ProductoComercio.model";
import AlertasPresentacion from "./AlertasPresentacion";
import { consultarTransaccionesAgrupadasCierreLote, consultarTransaccionesConDetalleMF} from "../services/transacciones.service";
import { NumericFormat } from "react-number-format";
import { consultarPresentacionesIniciadas } from "../../Consulta/Services/presentaciones.services";
import { getProductosComercio } from "../services/comercio.service";
import { isCombustibleAfines, isEmptyArrayOrNull, isNullOrUndef } from "../utilities/utils";
import { HttpStatusCode } from "axios";
import { consultarFacturasPresentacion } from "../services/facturas.service";
import './impuestosTasas.css';
import { STORAGE_LOCAL } from "../../shared/models/storages";
import { getUrlParam, useRemoveLocalStorage } from "../../shared/models/routes";
import { isNullOrEmpty } from "../../shared/utilitties/string.utilities";
import ComprobantesOCR from "./ComprobantesOCR";
import { HavePermissionOCR } from "../services/presentaciones.services";
 
//  TODO: HA MEDIDA QUE SE VAN FIXEANDO BUGS Y AGRGANDO FUNCIONALIDADES HABRIA QUE
//  REFACTORIZAR ESTE COMPONENTE PORQUE TIENE MUCHO CODIGO MALFORMADO
const IngresoDePresentaciones = () => {
  const { comercioSelecionado, userSessionModulo } = useGlobalContext();

  const { showDeclaracionDeImpuestosTasas, showMask,setPresentacionEditable,presentacionComercio,setPresentacionComercio,
    setPresentacion,setProductosComercio, selectedProductoComercio,setSelectedProductoComercio,
      totalImpuestosMF, setTotalImpuestosMF, setComprobantes, 
      setDetailsTxMF, setSumImpuestosMF, sumImpuestosMF, setPresentacionState,
    presentacionOCR,setpresentacionOCR
     } = usePresentacionContext();
    const [activeIndex, setActiveIndex] = useState([0, 1]);
    const [forbidden, setForbidden] = useState(false);
    const { state } = useLocation();
    const [mountPresentacionesAccordion,setMountPresentacionesAccordion] = useState(false)
    // const [presentacionOCR,setpresentacionOCR] = useState(false)
     
    let rowData = {pre_cupon: 0,impuestos_manual:0 };
    if (window.location.href.indexOf("presentacion=") > 0 && state) {
      rowData = JSON.parse(state);
    }

    useEffect(() => {
        (async () => {
            const { data, status } = await getPresentation();
            if (
              isNullOrUndef(data) || 
              isEmptyArrayOrNull(data.presentacionesComercio) ||
              status !== HttpStatusCode.Ok) return;
            
            const  permisoOCR = await HavePermissionOCR();
            setpresentacionOCR(permisoOCR.data.presentacionOCR);
            const { grupo_producto, pre_cupon, descripcion } = data.presentacionesComercio[0];
            const result_prod_comercios = await getProductosComercio();
            if (result_prod_comercios.status === HttpStatusCode.Ok) {
                await setDefaultGrupoproducto({
                  pre_cupon, 
                  grupo_producto, 
                  productos_comercio: result_prod_comercios.data
                });
            } else {
                console.log("grupoProductos", result_prod_comercios.status)
            }
            if (descripcion === INICIADA_COMERCIO || descripcion === RECHAZADA) {
                setPresentacionEditable(true)

            } else {
                let itemTabs = [0, 1, 2, 3]
                setActiveIndex([...itemTabs])
                setPresentacionEditable(false)
            }
            setPresentacionState(data.presentacionesComercio[0].descripcion);
            setPresentacionComercio(data.presentacionesComercio[0]);
            setPresentacion(pre_cupon);
            const facturas = await consultarFacturasPresentacion(pre_cupon);
            if (facturas.status == HttpStatusCode.Ok) {
              if(facturas.data.facturasIngresada.length > 0 ){
                const totalImpuestos = facturas.data.facturasIngresada.reduce((acc:number,obj:any) => acc + obj.fac_impuestos,0);
                setSumImpuestosMF(totalImpuestos);
              }

              setComprobantes(facturas.data.facturasIngresada);
            }

            useRemoveLocalStorage(STORAGE_LOCAL.EMAIL_DIRECTED, () => {
              setMountPresentacionesAccordion(true);
            });
        })()
    }, [comercioSelecionado])

    useEffect(() => {
      if (showDeclaracionDeImpuestosTasas == -1) return;
      onChangeTabActive(2);
    }, [showDeclaracionDeImpuestosTasas]);

  const onChangeTabActive = (itemIndex: number) => {
    let _activeIndex = activeIndex ? [...activeIndex] : [];

    if (_activeIndex.length === 0) {
      _activeIndex.push(itemIndex);
    } else {
      const index = _activeIndex.indexOf(itemIndex);
      if (index === -1) {
        _activeIndex.push(itemIndex);
      }
      /*else {
            _activeIndex.splice(index, 1);
        }*/
    }

    setActiveIndex(_activeIndex);
  };

  const getPresentation : () => Promise<any> = async () => {
    let presentacion_iniciada = null;
    if (isEmptyArrayOrNull(comercioSelecionado)) return { data: null, status: HttpStatusCode.UnprocessableEntity };

    if ( !isNullOrEmpty(getUrlParam("presentacion"))) {
      presentacion_iniciada = await consultarPresentacionesIniciadas(parseInt(getUrlParam("presentacion")!), rowData.impuestos_manual);
    } else {
      presentacion_iniciada = await consultarPresentacionesIniciadas(rowData.pre_cupon, userSessionModulo ? IMPUESTO_MANUAL : IMPUESTO_AUTOMATICO);
    }

    const { data, status } = await presentacion_iniciada;
    if (
      status !== HttpStatusCode.Ok || data === null ||
      data?.presentacionesComercio === null || data.presentacionesComercio.length < 1 ||
      data.presentacionesComercio[0].red_id !== comercioSelecionado[0].comercioId || 
      (getUrlParam("presentacion") !== null && data.presentacionesComercio[0].pre_cupon !== parseInt(getUrlParam("presentacion")!))
    ) {
      return useRemoveLocalStorage(STORAGE_LOCAL.EMAIL_DIRECTED, () => {
        setForbidden(true);
      
        return { data: null, status: HttpStatusCode.Unauthorized };
      });
    }
    
    return { data, status };
  }

  const updateTabActive = (itemIndex: any) => {
    let _activeIndex = [...itemIndex];
    setActiveIndex(_activeIndex);
  };

  const setDefaultGrupoproducto : (pars: {
    pre_cupon: any;
    grupo_producto:number; 
    productos_comercio:any;
  }) => void = async ({
    pre_cupon, 
    grupo_producto, 
    productos_comercio
  }) => {
    let selecedProduct = false
    setProductosComercio(productos_comercio.grupoProductos);
    if(grupo_producto === 0){
      if (productos_comercio.grupoProductos.length > 0) {
          setProductosComercio(productos_comercio.grupoProductos);
          if(productos_comercio.grupoProductos.length > 1){
  
            for (const itemGrupoProducto of productos_comercio.grupoProductos) {
              if(isCombustibleAfines(itemGrupoProducto.grupoProductoId)) {
                const {data,status} = await consultarTransaccionesAgrupadasCierreLote(pre_cupon, itemGrupoProducto.grupoProductoId);
                if (status === 200) {
                  if(data.transaccionesSeleccionadas.length > 0){
                    setSelectedProductoComercio(itemGrupoProducto);
                    selecedProduct = true
                    break
                  }
                }
  
              }else{
                let resultTxMF = await consultarTransaccionesConDetalleMF(pre_cupon,itemGrupoProducto.grupoProductoId)
                if(resultTxMF.status === 200){
                  setDetailsTxMF(resultTxMF.data);
                  if(resultTxMF.data.transaccionesSeleccionadas.length > 0){
                    setSelectedProductoComercio(itemGrupoProducto);
                    selecedProduct = true
                    setTotalImpuestosMF(resultTxMF.data.totalesSeleccionadas.impuesto)
                    break
                  }
                }
              }
            }
  
          }else{
            setSelectedProductoComercio(productos_comercio.grupoProductos[0]);
            console.log(productos_comercio.grupoProductos[0])
            selecedProduct = true
          }
          if(!selecedProduct){
            setSelectedProductoComercio(productos_comercio.grupoProductos[0]);
          }
      }
    }else{
      let  tipoDeProductoCombustible:ProductoComercio[]
      if(isCombustibleAfines(grupo_producto)){
        const grupoProductos: ProductoComercio[] = productos_comercio?.grupoProductos ?? []; 
        const selected = grupoProductos.find(p => p.grupoProductoId === grupo_producto) ?? grupoProductos[0]; 
        setSelectedProductoComercio(selected);
      }else{
        tipoDeProductoCombustible = productos_comercio.grupoProductos.filter((item:ProductoComercio) => item.grupoProductoId === grupo_producto)

        let resultTxMF = await consultarTransaccionesConDetalleMF(pre_cupon, tipoDeProductoCombustible[0].grupoProductoId)
        setSelectedProductoComercio(tipoDeProductoCombustible[0]);
        if(resultTxMF.status === 200){
          setDetailsTxMF(resultTxMF.data);
          if(resultTxMF.data.transaccionesSeleccionadas.length > 0){
            setTotalImpuestosMF(resultTxMF.data.totalesSeleccionadas.impuesto)
          }
        }
      }
    }
  };

  if (forbidden) return <Redirect to={'unauth'}/>;
  if (!mountPresentacionesAccordion) return <Mask>  <ProgressSpinnerDemo/> </Mask>

  return (
    <>
    {showMask && <Mask> <ProgressSpinnerDemo/> </Mask>}
    <div className="accordion-demo">
      <div className="card">
      <AlertasPresentacion/>
        <Accordion
          multiple
          activeIndex={activeIndex}
          onTabChange={(e) => updateTabActive(e.index)}
        >
          <AccordionTab header="DATOS GENERALES" >
            <PresentacionesDatosGenerales />
          </AccordionTab>
          <AccordionTab header="SELECCIÓN DE TRANSACCIONES" >
            <TransaccionesLotes />
          </AccordionTab>
          <AccordionTab header="INGRESO DE COMPROBANTES" >
             {
               presentacionOCR && <ComprobantesOCR />
             } 
             {
               !presentacionOCR && <Comprobantes />
             }
          </AccordionTab>
          { isCombustibleAfines(selectedProductoComercio.grupoProductoId)&& <AccordionTab header="DECLARACION DE ITC/IDC/TASAS" >
            <div className="p-grid p-align-center">
              <div className="p-col-12 p-sm-12">
                <div>
                  <div className="card">
                    {
                      window.location.href.indexOf("presentacion=") > 0 && rowData.impuestos_manual === 0 && <ImpuestosTasasDataTableAutomatico/>
                    }
                    {
                      window.location.href.indexOf("presentacion=") > 0 && rowData.impuestos_manual === 1 && <ImpuestosTasas />
                    }
                    {
                      (window.location.href.indexOf("presentacion=") === -1  && presentacionComercio.impuestos_manual === 0) && <ImpuestosTasasDataTableAutomatico/>
                    }
                    {
                      (window.location.href.indexOf("presentacion=") === -1  && presentacionComercio.impuestos_manual === 1) && <ImpuestosTasas /> 
                    }
                  </div>
                </div>
              </div>
            </div>
          </AccordionTab>
          }
          {
            !isCombustibleAfines(selectedProductoComercio.grupoProductoId) && <AccordionTab className={` ${totalImpuestosMF > 0 ? '' : 'd-none'} `} header="DECLARACION DE IMPUESTOS" >
            <div className="card">
              <div className="p-grid">
                <div className="p-col-12 p-md-11" style={{textAlign:"left"}}><p className="t4">Total impuestos</p></div>
                <div className="p-col-12 p-md-1">
                        <NumericFormat
                          value={totalImpuestosMF}
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          prefix={"$"}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                </div>
              </div>
              <div className="p-grid">
                <div className="p-col-12 p-md-11" style={{textAlign:"left"}}><p className="t4">Total impuestos Declarados</p></div>
                <div className="p-col-12 p-md-1">
                        <NumericFormat
                          value={sumImpuestosMF}
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          prefix={"$"}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                </div>
              </div>
              <div className="p-grid">
                <div className="p-col-12 p-md-11" style={{textAlign:"left"}}><p className="t4">Diferencia de impuestos</p></div>
                <div className="p-col-12 p-md-1">
                        <NumericFormat
                          value={totalImpuestosMF - sumImpuestosMF}
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          prefix={"$"}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                </div>
              </div>
            </div>
            </AccordionTab>
          }
          
          
        </Accordion>
        <AccionesPresentaciones/>        
        
      </div>
    </div>
    </>    
  );
};

export default IngresoDePresentaciones;
